import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "kaylas_garden_token";

export const kaylasClient = axios.create({ baseURL: `${BACKEND}/api` });
kaylasClient.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const KaylasCtx = createContext({ profile: null, token: null, login: null, logout: null });

export function KaylasAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(!!token);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    let cancelled = false;
    const refresh = async () => {
      try {
        const r = await kaylasClient.get("/kayla/me");
        if (!cancelled) setProfile(r.data);
      } catch {
        if (cancelled) return;
        localStorage.removeItem(TOKEN_KEY);
        setToken(null);
        setProfile(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    refresh();
    return () => { cancelled = true; };
  }, [token]);

  const login = useCallback(async (username, password) => {
    const r = await kaylasClient.post("/kayla/auth/login", { username, password });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setToken(r.data.token);
    setProfile(r.data.profile);
    return r.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setProfile(null);
  }, []);

  return (
    <KaylasCtx.Provider value={{ token, profile, loading, login, logout }}>
      {children}
    </KaylasCtx.Provider>
  );
}

export const useKaylas = () => useContext(KaylasCtx);
